/* eslint-disable react/jsx-one-expression-per-line */
import { ReactComponent as Phone } from 'assets/icons/phone.svg'
import classNames from 'classnames'
import { Link } from 'ui'
import { isLkmDomain } from 'router/utils'
import { Fragment } from 'react'

import styles from './Footer.module.scss'

const linksMap = [
  {
    name: 'Политика конфиденциальности',
    url: '/privacy-policy',
  },
  {
    name: 'Основной сайт DoorHan',
    url: 'https://doorhan.ru/',
  },
  {
    name: 'Пользовательское соглашение',
    url: '/term-of-use',
  },

  {
    name: 'Соглашение на обработку ПДн',
    url: '/personalagreement',
  },
]

const lkmLinks = ['/privacy-policy', '/personalagreement']

// подвал сайта
export function Footer({ className }: { className?: string }) {
  const isLkm = isLkmDomain()
  const visibleLinks = isLkm
    ? linksMap.filter(item => lkmLinks.includes(item.url))
    : linksMap

  return (
    <footer className={classNames(styles.footer, className)}>
      <div className={classNames('container', styles.footerContainer)}>
        <div className={classNames(styles.footerMenu, styles.menuLeft)}>
          {visibleLinks.map(item => (
            <Fragment key={item.url}>
              <div className={classNames(styles.footerMenuItem)}>
                <Link
                  href={item.url}
                  className={classNames(
                    styles.footerMenuLink,
                    styles.footerTitleLink,
                  )}
                  underline='none'
                  target='_blank'
                >
                  <span
                    className={classNames(
                      styles.footerTitle,
                      styles.footerPolicy,
                      'h4',
                    )}
                  >
                    {item.name}
                  </span>
                </Link>
              </div>
              <div className={styles.line} />
            </Fragment>
          ))}
        </div>

        <div className={classNames(styles.footerMenu, styles.menuRight)}>
          <div
            className={classNames(
              styles.footerMenuItem,
              styles.footerContactBlock,
            )}
          >
            <span className={classNames(styles.footerTitle, 'h4')}>
              Контакты
            </span>
            <Link
              href='tel:88002002208'
              className={styles.footerMenuLink}
              underline='none'
            >
              <Phone />8 (800) 200-22-08 (служба поддержки)
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
